<template>
	<div class="landing-container elevation-2" id="container">
		<div class="form--container sign-up-container pa-4 ma-1">
			<sign-up-form
				:isDistributor="true"
				:themeInputColor="themeInputColor"
				@showSignIn="signInActive"
			/>
		</div>
		<div
			class="form--container sign-in-container px-4 py-4 allCenteredChild"
		>
			<sign-in-form
				:themeInputColor="themeInputColor"
				@showSignUp="signUpActive"
			/>
		</div>
		<!-- <div class="overlay-container">
			<div class="overlay">
				<div class="overlay-panel overlay-left">
					<img :src="logo" style="width:30%;" />
					<h1>Welcome Back!</h1>
					<p>To keep connected with us please login with your personal info</p>
					<v-btn id="signIn" outline color="white" @click="signInActive">Log In</v-btn>
				</div>
				<div class="overlay-panel overlay-right">
					<img :src="logo" style="width:30%;" />

					<h1>Hello, Friend!</h1>
					<p>Enter your personal details and start journey with us</p>
					<v-btn id="signUp" outline color="white" @click="signUpActive">Sign Up</v-btn>
				</div>
			</div>
		</div>-->
		<v-snackbar bottom right v-model="alert.show">{{
			alert.text
		}}</v-snackbar>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import SignUpForm from "../Landing/sign-up-form";
import SignInForm from "../Landing/sign-in-form";

import logo from "@/assets/logo_outline.svg";
import { FETCH_ALL_LANGUAGES } from "@/store/action-types";

export default {
	name: "Landing",
	data() {
		return {
			themeInputColor: "blue darken-1",
			logo
		};
	},
	components: {
		"sign-up-form": SignUpForm,
		"sign-in-form": SignInForm
	},
	created() {
		this.$store.dispatch(FETCH_ALL_LANGUAGES.dispatch).catch(err => {
			console.error(err);
		});
		if (this.ACCESS_TOKEN) {
			this.changeRoutes();
		}
	},
	mounted() {
		this.container = document.getElementById("container");
	},
	computed: {
		...mapState({
			alert: state => state.common.alert,
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN
		}),
		...mapGetters({
			isRetailAdmin: "auth/isRetailAdmin",
			isRetailer: "auth/isRetailer",
			isFinanceAdmin: "auth/isFinanceAdmin",
			isJeet11Partner: "auth/isJeet11Partner",
			isJeet11Distributor: "auth/isJeet11Distributor"
		})
	},
	methods: {
		signUpActive() {
			this.container.classList.add("right-panel-active");
		},
		signInActive() {
			this.container.classList.remove("right-panel-active");
		},
		changeRoutes() {
			if (this.isRetailer) {
				if (this.isJeet11Distributor) {
					this.$router.replace("/jeet11distributor");
				} else if (this.isJeet11Partner) {
					this.$router.replace("/jeet11");
				} else {
					this.$router.replace("/posts");
				}
			} else if (this.isRetailAdmin) {
				this.$router.replace("/review");
			} else if (this.isFinanceAdmin) {
				this.$router.replace("/acknowledge");
			}
		}
	},
	watch: {
		ACCESS_TOKEN(newVal) {
			if (newVal !== null && newVal) {
				this.changeRoutes();
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.landing-container {
	max-width: 600px;
	width: 90%;
	margin: auto;
	border-radius: 10px;
	position: relative;
	overflow: hidden;
	height: 700px;
	&.right-panel-active {
		.sign-in-container {
			// transform: translateX(67%);
			opacity: 0;
		}
		.sign-up-container {
			// transform: translateX(67%);
			opacity: 1;
			z-index: 5;
			animation: show-sign-in cubic-bezier(0.4, 0, 1, 1) 0.7s;
		}
		.overlay-container {
			transform: translateX(-150%);
		}
		.overlay {
			transform: translateX(50%);
		}
		.overlay-left {
			transform: translateX(0);
		}
		.overlay-right {
			transform: translateX(40%);
		}
	}
}

.form--container {
	position: absolute;
	top: 0;
	height: 100%;
	transition: all 0.6s ease-in-out;
	overflow-y: scroll;
	&.sign-in-container {
		left: 0;
		width: 100%;
		z-index: 2;
	}
	&.sign-up-container {
		left: 0;
		width: 100%;
		opacity: 0;
		z-index: 1;
	}
}

@keyframes show-sign-in {
	0% {
		opacity: 0;
		z-index: 1;
	}
	100% {
		opacity: 1;
		z-index: 5;
	}
}

.overlay-container {
	position: absolute;
	top: 0;
	left: 60%;
	width: 40%;
	height: 100%;
	overflow: hidden;
	transition: transform 0.6s ease-in-out;
	z-index: 100;
	.overlay {
		background: linear-gradient(to right, #42a5f5, #1565c0);
		background-repeat: no-repeat;
		background-size: cover;
		background-position: 0 0;
		color: #ffffff;
		position: relative;
		left: -100%;
		height: 100%;
		width: 200%;
		transform: translateX(0);
		transition: transform 0.6s ease-in-out;
	}
}

.overlay-panel {
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	padding: 0 40px;
	text-align: center;
	top: 0;
	height: 100%;
	width: 50%;
	transform: translateX(0);
	transition: transform 0.6s ease-in-out;
}

.overlay-left {
	transform: translateX(-20%);
}

.overlay-right {
	right: 0;
	transform: translateX(0);
}
</style>
